import React from 'react';
import './Savings.css';

const savings = [
  {
    area: 'Time Recovered',
    num: '10hrs',
    desc: 'Small businesses save an average of 10 hours per week by automating manual, repetitive tasks like data entry, scheduling, and invoicing.',
    source: 'Zapier, State of Business Automation Report',
  },
  {
    area: 'Lead Response',
    num: '21\u00D7',
    desc: 'You are 21 times more likely to qualify a lead if you respond within 5 minutes. Automation makes instant response the default.',
    source: 'Harvard Business Review / InsideSales.com',
  },
  {
    area: 'Faster Payments',
    num: '2\u00D7',
    desc: 'Businesses using automated invoicing get paid up to twice as fast \u2014 averaging 14 days versus 30+ days for manual invoicing.',
    source: 'Xero, State of Small Business Report',
  },
  {
    area: 'Operating Costs',
    num: '-25%',
    desc: 'Automation can reduce business operating costs by 20\u201330% across marketing, sales, and day-to-day operations.',
    source: 'Deloitte, Global Automation Survey',
  },
  {
    area: 'No-Shows',
    num: '-39%',
    desc: 'Automated appointment reminders reduce no-shows by up to 39%, keeping your calendar full and your revenue steady.',
    source: 'BMC Health Services Research',
  },
  {
    area: 'First Year ROI',
    num: '250%',
    desc: 'Businesses that adopt automation report an average return on investment of 250% within the first year of implementation.',
    source: 'Nucleus Research',
  },
];

const Savings: React.FC = () => {
  return (
    <section className="savings" id="savings">
      <div className="savings-inner">
        <div className="savings-head reveal">
          <span className="eyebrow" style={{ color: 'rgba(255,255,255,0.35)' }}>The numbers speak for themselves</span>
          <h2>What automation <em>actually</em> delivers.</h2>
          <p>Industry research from businesses across Ireland, the UK, and beyond.</p>
        </div>
        <div className="savings-grid reveal">
          {savings.map((s, i) => (
            <div className="saving" key={i}>
              <div className="saving-area">{s.area}</div>
              <span className="saving-num">{s.num}</span>
              <div className="saving-desc">{s.desc}</div>
              <div className="saving-source">{s.source}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Savings;
